export default __webpack_public_path__ + "static/media/GratefulForMyBody2021.9722e612.jpg";